<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { settingService } from '../../../services';
import config from "../../../config";
import { success_message, error_message } from '../../../Helper/helper';

/**
 * Starter component
 */
export default {
  data() {
    return {
      config:config,
      setting: [],
      setting: {
        restaurant_item_layout: ''
      }
    };
  },
  validations: {
    setting: {
      restaurant_item_layout: {
        required : requiredIf(function(form){
        	return !this.setting.restaurant_item_layout;
        })
      }
    },
  },
  mounted() {
    this.getAppSetting();
  },
  methods: {
    getAppSetting(){
      settingService.getAppSettingApi().then((response) => {
        const {
            restaurant_item_layout
        } = response.data.result.settings;
            this.setting = {
               restaurant_item_layout: restaurant_item_layout || '1',
            };
      })
    },
    generalIt(){
      this.$v.setting.$touch();
      if (this.$v.setting.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("restaurant_item_layout", this.setting.restaurant_item_layout);
        fd.append('type',5);
        settingService.updateAppSetting(fd).then((response) => {
          if (response.data.code === 200) {
              success_message(response.data.message);
            } else {
              error_message(response.data.message);
            }
        });
      }
    }
  }
};
</script>
<template>
  <b-form @submit.prevent="generalIt">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group" v-if="$auth.setting">
                  <label class="control-label">{{ trans.get('__JSON__.Vendor Details Page Layout',{ vendor: $auth.setting.restaurant_name }) }}</label>
                  <select class="custom-select" id="restaurant_item_layout" name="restaurant_item_layout" v-model="setting.restaurant_item_layout">
                    <option v-bind:value="1" selected>{{ trans.get('__JSON__.Layout 1') }}</option>
                    <option v-bind:value="2">{{ trans.get('__JSON__.Layout 2') }}</option>
                    <option v-bind:value="3">{{ trans.get('__JSON__.Layout 3') }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6 offset-sm-3">
                <div class="form-group">
                  <label class="control-label">{{ trans.get('__JSON__.Preview') }}</label>
                  <div v-if="setting.restaurant_item_layout == '1'" class="home-layout">
                    <img :src="config.vendordetailimage+'1.png'">
                  </div>
                   <div v-else-if="setting.restaurant_item_layout == '2'" class="home-layout">
                    <img :src="config.vendordetailimage+'2.png'">
                  </div>
                  <div v-else-if="setting.restaurant_item_layout == '3'" class="home-layout">
                    <img :src="config.vendordetailimage+'3.png'">
                  </div>
                </div>
              </div>
            </div>

            <div class="btn-update">
              <div class="col-sm-6">
                <button
                  v-if="$auth.hasPermission(config.permissions.layout_write)"
                  type="submit"
                  class="btn btn-primary mr-1 mt-3"
                >{{ trans.get('__JSON__.Update') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>